<template>
	<div class="main" style="width:1440px;margin: 0 auto;">
		<div class="banner_box">
			<img src="/banner02.jpg" alt="" width="1440px" height="300px">
		</div>
		<div class="container">
			<div class="text">
				<div>公司：{{info.name}}</div>
				<div>地址：{{info.address}}</div>
				<div>电话：{{info.phone}}</div>
				<div>邮箱：{{info.email}}</div>
			</div>
			<div id="map">
				<div id="map_box" ></div>
			</div>
		</div>
	</div>
</template>
<script>
	
	import Vue from 'vue';
	import {
		imgurl,getAction,putformAction
	} from "@/api/manage";
		
		
	export default {
		name: 'HelloWorld4',
		props: {
			msg: String
		},
		data() {
			return {
				imgurl: imgurl,
				info: {},
				map:"",
			}
		},
		// mounted(e) {
		// 	this.initMap()
		// },
		mounted() {
			this.getinfo()
			if (typeof BMap === 'undefined') {
				this.loadBMap().then(() => {
					this.initMap();
				});
			} else {
				this.initMap();
			}
		},


		methods: {
			loadBMap() {
				return new Promise((resolve, reject) => {
					if (typeof BMap !== 'undefined') {
						resolve();
						return;
					}
			
					window.BMap_init = function() {
						resolve();
					};

					const script = document.createElement('script');
					script.src = `https://api.map.baidu.com/api?v=3.0&ak=Tqz5H5NyBX2baxF3cPZyqyFbttTro4kp&callback=BMap_init`;
					script.onerror = reject;
					document.head.appendChild(script);
				});
			},
			
			initMap() {
				// 创建地图实例
				const map = new BMap.Map("map_box");    // 创建Map实例
				const point = new BMap.Point('113.35520', '22.939307');  // 创建点坐标
				map.centerAndZoom(point, 20);                   // 初始化地图，设置中心点坐标和地图级别
			  
				var marker = new BMap.Marker(point);        // 创建标注
				map.addOverlay(marker);                    // 将标注添加到地图中
			},
			
			getinfo(){
				let that = this;
				let param = {};
				getAction("viwo/homePage/getMainInfo", param).then(res => {
					if (res.success && res.result) {
						that.info = res.result;
						console.log("公司信息res===",res)
					}
				})
			},
			
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	.main {
		width:1440px;
		margin: 0 auto; 
		// min-height: 1426px;
	}
	a {
		text-decoration: none;
	}
	.banner_box {
		height: 300px;
	}
	.container {
		width: 1440px;
		height: 600px;
		margin: auto;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}
	.text {
		display: flex;
		flex-direction: column;
		justify-content: center;
		width: 50%;
		line-height: 50px;
		background-color: rgba(255,255,255,1);
		color: rgba(16,16,16,1);
		font-size: 36px;
		text-align: center;
		font-family: -regular;
		div{
			width: 600px;
			text-align: left;
			margin-left: 80px;
		}
	}
	#map {
		width: 50%;
		padding: 68px;
		box-sizing: border-box;
	}
	#map_box {
		width: 100%;
		height: 100%;
	}
	
	
</style>